/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import {
  Row, Col, Spin, Form, Input, Modal, Button,
} from 'antd';
import {
  ExclamationCircleOutlined,
} from '@ant-design/icons';

import Table from 'components/Table';
import Select from 'components/Select';
import FormSubmitControls from 'components/FormSubmitControls'; // Usamos tu componente de controles
import { onError, onSuccess } from 'utils/handlers';

// API catálogos
import { getPeriodosDeNominasDetalles } from 'api/nominas/periodos/periodosDeNominasDetalle';

// API CRUD
import {
  getSolicitudesPercepcionesPeriodos,
  postSolicitudPercepcionPeriodo,
  deleteSolicitudPercepcionPeriodo,
} from 'api/nominas/solicitudes/solicitudesPercepcionesPeriodos';

const { confirm } = Modal;

const SolicitudesPercepcionesPeriodos = ({
  selected,
  allowControls,
}) => {
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false); // Estado para el Modal
  const [periodosCombo, setPeriodosCombo] = useState([]);
  const [periodosAsignados, setPeriodosAsignados] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  const [form] = Form.useForm();

  // Cargar datos
  const loadAll = async () => {
    try {
      if (!selected?.id) {
        setPeriodosAsignados([]);
        return;
      }

      setLoading(true);
      const [_combo, _asignados] = await Promise.all([
        getPeriodosDeNominasDetalles(),
        getSolicitudesPercepcionesPeriodos({
          solicitud_percepcion: selected.id,
        }),
      ]);

      setPeriodosCombo(_combo);
      setPeriodosAsignados(_asignados);
    } catch (err) {
      onError(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadAll();
    // eslint-disable-next-line
  }, [selected]);

  const onClickAdd = () => {
    if (!selected?.id) {
      return;
    }
    form.resetFields();
    setOpen(true);
  };

  const onCancel = () => {
    setOpen(false);
    form.resetFields();
  };

  const onFinish = async (values) => {
    try {
      setLoading(true);

      const payload = {
        solicitud_percepcion: selected.id,
        periodo_de_nomina_detalle: values.periodo_de_nomina_detalle,
      };

      const res = await postSolicitudPercepcionPeriodo(payload);

      if (res) {
        onSuccess(res, 'Periodo agregado correctamente');
        onCancel();
        await loadAll();
      }
    } catch (err) {
      onError(err, setLoading);
    } finally {
      setLoading(false);
    }
  };

  const onClickDelete = () => {
    if (!selectedRowKeys.length) return;

    confirm({
      title: '¿Estás seguro de eliminar este periodo?',
      icon: <ExclamationCircleOutlined />,
      content: 'Esta acción no se puede deshacer.',
      okText: 'Sí, eliminar',
      okType: 'danger',
      cancelText: 'Cancelar',
      onOk: async () => {
        try {
          setLoading(true);
          const [id] = selectedRowKeys;
          const ok = await deleteSolicitudPercepcionPeriodo(id);
          if (ok) {
            setSelectedRowKeys([]);
            onSuccess(ok, 'Periodo eliminado correctamente');
            await loadAll();
          }
        } catch (err) {
          onError(err);
        } finally {
          setLoading(false);
        }
      },
    });
  };

  const columns = [
    {
      titleText: 'Periodo',
      dataIndex: 'periodo_descripcion',
      key: 'periodo_descripcion',
      width: 280,
    },
    {
      titleText: 'Estatus',
      dataIndex: 'estatus_descripcion',
      key: 'estatus_descripcion',
      width: 150,
    },
  ];

  const rowSelection = {
    type: 'radio',
    selectedRowKeys,
    onChange: (keys) => setSelectedRowKeys(keys),
  };

  return (
    <Row className="container">
      <Col span={24}>
        <Spin spinning={loading}>
          {/* TABLA PRINCIPAL */}
          <Table
            cols={columns}
            data={periodosAsignados}
            rowSelection={rowSelection}
            allowPagination={false}
            allowExportParam={false}
            handleOnRowClick={(r) => setSelectedRowKeys([r.id])}
            // controls={{
            //   onClickAdd: allowControls ? onClickAdd : null,
            //   onClickDelete: allowControls ? onClickDelete : null,
            // }}
            permission={{
              hasAllViewPermission: true,
              add: true,
              delete: true,
            }}
            hasAllViewPermission
          />

          {/* MODAL PARA AGREGAR */}
          <Modal
            open={open}
            onCancel={onCancel}
            closable={false}
            maskClosable={!loading}
            footer={null}
            destroyOnClose
            title={(
              <FormSubmitControls
                label="Agregar Periodo"
                onFinish={() => form.submit()}
                onCancel={onCancel}
                loading={loading}
                allowSave
                onFinishText="Guardar"
              />
            )}
          >
            <Form
              form={form}
              layout="vertical"
              onFinish={onFinish}
              initialValues={{
                estatus_visual: 'Activo',
              }}
            >
              <Row gutter={16}>
                <Col span={24}>
                  <Form.Item
                    name="periodo_de_nomina_detalle"
                    label="Periodo de Nómina"
                    rules={[{ required: true, message: 'Seleccione un periodo' }]}
                  >
                    <Select
                      dataSource={periodosCombo}
                      keyProp="id"
                      labelProp="numero_de_nomina"
                      render={(item) => `${item.numero_de_nomina} (${item.fecha_inicial} - ${item.fecha_final})`}
                    />
                  </Form.Item>
                </Col>

                <Col span={24}>
                  <Form.Item
                    name="estatus_visual"
                    label="Estatus"
                  >
                    <Input
                      disabled
                      style={{ backgroundColor: '#f5f5f5', color: 'rgba(0, 0, 0, 0.85)' }}
                    />
                  </Form.Item>
                </Col>

                <Form.Item hidden>
                  <Button htmlType="submit" />
                </Form.Item>
              </Row>
            </Form>
          </Modal>

        </Spin>
      </Col>
    </Row>
  );
};

export default SolicitudesPercepcionesPeriodos;
